import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

import {
  PROJECT_ID,
  TOMIS_DEV_GA4_MEASUREMENT_ID,
  TOMIS_GA4_MEASUREMENT_ID,
} from './consts';

/** Firebase Storage bucket URI */
export const storageBucket = `${PROJECT_ID}.appspot.com`;

const devConfig = {
  apiKey: 'AIzaSyBtrL_RalzE4ZxfpGM5gKKpwI4zZaBqyls',
  authDomain: 'tomis-bot-dev.firebaseapp.com',
  databaseURL: 'https://tomis-bot-dev.firebaseio.com',
  projectId: 'tomis-bot-dev',
  storageBucket,
  messagingSenderId: '882202527104',
  appId: '1:882202527104:web:7c77bdf67cb1869deb2d65',
  measurementId: TOMIS_DEV_GA4_MEASUREMENT_ID,
};

const productionConfig = {
  projectId: PROJECT_ID,
  apiKey: 'AIzaSyD_Gfc_7uxkBQCYz7KRAVnUW5-K2gONcEk',
  messagingSenderId: '620481618393',
  authDomain: 'tomis-bot.firebaseapp.com',
  databaseURL: 'https://tomis-bot.firebaseio.com',
  storageBucket,
  appId: '1:620481618393:web:a168024425db8ced0979c8',
  measurementId: TOMIS_GA4_MEASUREMENT_ID,
};

const config = PROJECT_ID === 'tomis-bot' ? productionConfig : devConfig;

/** Firebase object to use throughout the App */
export let FIREBASE: {
  /** Firebase App */
  app: firebase.app.App;
  /** Firestore Database */
  db: firebase.firestore.Firestore;
  /** Firebase Auth */
  auth: firebase.auth.Auth;
  /** Firebase Storage (e.g. Bot Icons) */
  storage: firebase.storage.Storage;
};

/** Returns UID of logged in Firebase User, else returns `null` */
export function getFirebaseUserId() {
  return FIREBASE.auth.currentUser ? FIREBASE.auth.currentUser.uid : null;
}

/** Configure Firebase before rest of iframe loads.
 *
 * Errors are fatal to chatbot loading */
export async function initFirebase() {
  try {
    const app = firebase.initializeApp(config);
    app.firestore().settings({
      /** Cannot be used with `experimentalForceLongPolling`. See comment here:
       * https://stackoverflow.com/questions/65594133/react-native-to-firestore-firestore-8-2-1-connection-webchannel-transport-er
       */
      experimentalAutoDetectLongPolling: true,
      merge: true,
      // Prevent undefined values from throwing an error when saving to Firebase
      ignoreUndefinedProperties: true,
    });
    /** Check if we have access to localStorage, to persist firestore & auth */

    try {
      localStorage.getItem('getRandomValueToTestLocalStorage');
      // Enable Firestore offline mode if we have access to localStorage:
      // https://firebase.google.com/docs/firestore/manage-data/enable-offline
      // await app
      // .firestore()
      // .enablePersistence({ synchronizeTabs: true })
      // .catch(console.warn);

      // Persist Firebase auth state across pageviews if we have access to localStorage
      await app
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .catch(console.warn);
    } catch (error) {
      // We don't have access to local storage, so we can't persist firestore or auth
      await app
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.NONE)
        .catch(console.warn);
    }

    /** Update firebase settings that will be used by iframe */
    FIREBASE = {
      /** Firebase App */
      app,
      /** Firestore Database */
      db: app.firestore(),
      /** Firebase Auth */
      auth: app.auth(),
      /** Firebase Storage (e.g. Bot Icons) */
      storage: app.storage(),
    };

    Object.freeze(FIREBASE);
  } catch (error) {
    console.error(error);
    throw new Error('Error loading Firebase SDK');
  }
}
